<template>
    <div>
          <p class="bigTitle"><span class="floor">*</span>商品管理>新增房型</p>
          <div class="body">
              <div class="content">
                     <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                         <p>商品基本类型</p>
                        <el-form-item label="商品名称" prop="name"><el-input v-model="ruleForm.name" class="productName"></el-input></el-form-item>
                        <el-form-item label="商品标题" prop="name"><el-input v-model="ruleForm.name" class="productName"></el-input></el-form-item>
                        <el-form-item label="商品分类" prop="region">
                            <el-select v-model="ruleForm.region" placeholder="请选择活动区域" class="productName">
                            <el-option label="区域一" value="shanghai"></el-option>
                            <el-option label="区域二" value="beijing"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="面积" prop="name"><el-input v-model="ruleForm.name" class="productName"></el-input></el-form-item>
                        <p>
                            床型： <el-input v-model="input" placeholder="请输入内容" class="foole"></el-input> 床宽: <el-input v-model="inputs" placeholder="请输入内容" class="foole"></el-input>  床数: <el-input v-model="inputs" placeholder="请输入内容" class="fooleC"></el-input>
                        </p>
                        <el-form-item label="窗户" prop="region">
                            <el-select v-model="ruleForm.region" placeholder="窗户/" class="productName">
                            <el-option label="有窗" value="shanghai"></el-option>
                            <el-option label="无窗" value="beijing"></el-option>
                            </el-select>
                        </el-form-item>

                        <hr class="hr"/>

                        <p>销售属性</p>
                        <el-form-item label="早餐" prop="region">
                            <el-select v-model="ruleForm.region" placeholder="有/无" class="productName">
                            <el-option label="含早" value="shanghai"></el-option>
                            <el-option label="不含早" value="beijing"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="入住人数" prop="name"><el-input v-model="ruleForm.name" class="productName"></el-input></el-form-item>
                        <el-form-item label="房量" prop="name"><el-input v-model="ruleForm.name" class="productName"></el-input></el-form-item>

                        <el-form-item label="活动性质" prop="type">
                            <el-checkbox-group v-model="ruleForm.type" class="active">
                            <el-checkbox label="电热水壶" name="type"></el-checkbox>
                            <el-checkbox label="免费无线上网" name="type"></el-checkbox>
                            <el-checkbox label="空调" name="type"></el-checkbox>
                            <br/>
                            <el-checkbox label="电视" name="type"></el-checkbox>
                            <el-checkbox label="24小时热水" name="type"></el-checkbox>
                            <el-checkbox label="拖鞋" name="type"></el-checkbox>
                            <el-checkbox label="书桌" name="type"></el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        
                        <el-form-item label="加床服务" prop="type">
                            <el-checkbox-group v-model="ruleForm.type" class="active">
                            <el-checkbox label="不可加床" name="type"></el-checkbox>
                            <el-checkbox label="无偿加床" name="type"></el-checkbox>
                            <el-checkbox label="有偿加床" name="type"></el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>

                        <p>
                            商品标签:
                            <el-tag :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false"  @close="handleClose(tag)">{{tag}}</el-tag>
                            <el-input class="input-new-tag"  v-if="inputVisible" v-model="inputValue"  ref="saveTagInput" size="small"  @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm"></el-input>
                            <el-button v-else class="button-new-tag tag" size="small" @click="showInput">+自定义</el-button>
                        </p>

                        取消政策:
                        <el-checkbox v-model="checked">免费取消</el-checkbox>
                        <el-checkbox v-model="checked">不可取消</el-checkbox>
                        <el-checkbox v-model="checked">30分钟内免费取消</el-checkbox>
                        <el-checkbox v-model="checked" class="cancelCheckbox">入住当天 <el-input v-model="input" class="cancelInput" placeholder="16:00"></el-input> 前可免费取消</el-checkbox>


                         <hr class="hr"/>

                        <p>图片管理</p>

                        <p>
                            <label>房间图片:</label><span class="hotelImg"><i class="el-icon-warning-outline"></i> 一次最多上传10张、图片为jpg或png格式</span> 
                        </p>
                        <el-upload class="imgList"  action="https://jsonplaceholder.typicode.com/posts/" list-type="picture-card"   :on-preview="handlePictureCardPreview"  :on-remove="handleRemove"> <i class="el-icon-plus"></i>  </el-upload>
                        <el-dialog :visible.sync="dialogVisible"> <img width="100%" :src="dialogImageUrl" alt=""> </el-dialog>

                        <el-button type="primary" class="saveButtom">提交审核</el-button>
                    </el-form>
              </div>
            
          </div>
    </div>    
</template>

<script>
  export default {
    data() {
      return {
        ruleForm: {
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        },
        rules: {
          name: [
            { required: true, message: '请输入活动名称', trigger: 'blur' },
            { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
          ],
          region: [
            { required: true, message: '请选择活动区域', trigger: 'change' }
          ],
          date1: [
            { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
          ],
          date2: [
            { type: 'date', required: true, message: '请选择时间', trigger: 'change' }
          ],
          type: [
            { type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change' }
          ],
          resource: [
            { required: true, message: '请选择活动资源', trigger: 'change' }
          ],
          desc: [
            { required: true, message: '请填写活动形式', trigger: 'blur' }
          ]
        },
        dynamicTags: ['立即确认', '含早', '双床','大床'],
        inputVisible: false,
        inputValue: ''
      };
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            alert('submit!');
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
        handleClose(tag) {
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      },

      showInput() {
        this.inputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },

      handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue) {
          this.dynamicTags.push(inputValue);
        }
        this.inputVisible = false;
        this.inputValue = '';
      }



    }
  }
</script>

<style scoped>

.bigTitle{
    text-align: left;
}

.floor{
    width: 15px;
    background-color: #0F86DA;
    color:#0F86DA;
    border-radius: 5px;
}


.body{
    background-color: #FFFFFF;
    border-radius: 10px;
}

.content{
    padding-top: 2%;
}

.productName{
    width: 20%;
    margin-right: 80%;
}

.foole{
    width: 19%;
    margin-right: 2%;
}
.fooleC{
    width: 20%;
    margin-right: 24%;
}

.active{
    margin-right: 75%;
}

.el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

  .hr{
      width: 98%;
      color:lavender;
  }

  .tag{
      margin-right: 68%;
  }

  .hotelImg{
      color: darkgray;
      margin-right: 75%;
  }

  .imgList{
       margin-right: 75%;
  }

  .saveButtom{
      margin-bottom: 5%;
  }

  .cancel{
      margin: 50%;
  }

  .cancelInput{
      width: 25%
  }

  .cancelCheckbox{
      margin-right: 45%;
  }

</style>


// WEBPACK FOOTER //
// src/components/Hotel/product/houseState/houseNew.vue